import { useFormContext } from 'react-hook-form';
import { EventPanelFormType } from '@mark43/cad-api';
import { debounce } from 'lodash';
import { FormRow } from '@cad-arc';
import { FormNewEventNarrativeInput } from '../../forms/integrated-form-controls/form-new-event-narrative-input';
import { createNewVehicleArrayFromNarrative } from '../../event-panel/event-panel-form/helpers/vehicle-helpers';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';

export function EventFormNarrativeInput({
    eventId,
    showRequiredIndicator,
    mode,
}: {
    eventId?: number;
    showRequiredIndicator?: boolean;
    mode?: 'read-only';
}) {
    const form = useFormContext<EventPanelFormType>();
    const {
        eventPanelConfiguration: eventConfiguration,
        eventPanelOptions: eventOptions,
    } = useBootstrapState();
    const defaultPurposeCode = eventConfiguration?.defaultPurposeCode;
    const defaultPlateType = eventConfiguration?.defaultPlateType;
    const defaultPlateYear = eventConfiguration?.defaultPlateYear;
    const defaultStateOptionValue = eventConfiguration?.defaultVehicleState?.value;

    if (eventId) {
        return null;
    }

    return (
        <FormRow>
            <FormNewEventNarrativeInput
                control={form.control}
                label="Narrative"
                name="narrative"
                showRequiredIndicator={showRequiredIndicator}
                asEditable={false}
                narrativeInputProps={{
                    mode,
                    onReplaceVehicles: debounce((vehicleStrings: string[]) => {
                        const currentVehicles = form.getValues('vehicles');
                        const newVehicles = createNewVehicleArrayFromNarrative({
                            vehicleStrings,
                            stateOptions: eventOptions?.stateOptions || [],
                            defaultStateOptionValue,
                            defaultPurposeCode,
                            defaultPlateType,
                            defaultPlateYear,
                            // @ts-expect-error there are custom temp fields ('plateNumberKey') injected to currentVehicles
                            currentVehicles,
                            addedViaNarrative: true,
                        });
                        // @ts-expect-error only vinNumber and stateOption can be set by narrative input
                        form.setValue('vehicles', newVehicles);

                        form.setValue('vehicleQueryAllOnSave', !!newVehicles.length);
                    }, 200),
                }}
            />
        </FormRow>
    );
}
